import { Auth, API } from 'aws-amplify';
import * as InfoContribuyente from '@/library/utils/info-contribuyente';
import router from '@/router';
import axios from 'axios'
import {API_CODIGO_ESTADOS_DTE} from '@/config'

let currentSucursalesApi;

export default {
	getEmpresas: async function({commit, dispatch, state, rootState, getters}/*, _limit=750*/) {

		let username = await dispatch('usuario/getCurrentUser', null, { root: true })
		commit('resetEmpresas', getters['seleccionada']);
		state.isloading = true;
		
		// TODO posiblemente paginar resultados.
		// coberg 07-ago-2020 autoriza que se traigan todos por mientras
		let succFun = function(res) {
			state.isloading = false;
			let contribuyentesUsuario = res.data;

			rootState.usuario.permisos = contribuyentesUsuario.secciones;
			commit('addEmpresas', contribuyentesUsuario);
			// if( getters['lista'].length === 1 )
			if( !getters['seleccionada'] )	
				dispatch('selectEmisor', getters['lista'][0]);
		};
		
		let errFun = function(err) {
		
		};
		
		InfoContribuyente.emisoresUsuario(username, succFun, errFun);
	},
	selectEmisor: async function( {commit,dispatch, rootState}, emisor ){
		commit('select', emisor);
		const currentRouteName = router.currentRoute.name;
		const calRouteName = 'calculadora-botonera';

		// Datos emisor
		let rutUsuario = rootState.usuario.username;
		let rutContribuyente = emisor.rut;

		rootState.usuario.isloadingPermisos = false;
		rootState.usuario.esRepresentante = true;
		rootState.usuario.permisos = [];

		if( currentRouteName !== calRouteName )	router.push({name:calRouteName})
	},
}